// src/components/IjrrGear/SingleProduct/ProductImagePanel.js

import React from 'react';

export default function ProductImagePanel({ imageUrl, productName }) {
  return (
    <div className="col-md-7 cdx-xl-45 ">
      <div className="product-card product-editor-wrap">
        <img
          className="img-fluid"
          src={imageUrl}
          alt={productName}
        />
      </div>
    </div>
  );
}